import { Button, Label } from 'semantic-ui-react';
import styled from 'styled-components';

export const TableFooterWrapper = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
`
export const StyledActionWrapper = styled.div`
display: flex;
align-items: baseline;
justify-content: space-evenly;
 >i.icon {
   font-size: 1.2rem !important;
 }
`

export const StyledFormWrapper = styled.div`
.react-datepicker-popper {
  z-index: 100 !important;
}
`

export const Popper = styled.div`
  && .react-datepicker__triangle:before,
  && .react-datepicker__triangle:after {
    left: -25px;
  }

  && .react-datepicker__triangle:after {
    border-bottom-color: #fff;
  }

  .react-datepicker--time-only {
    background-color: transparent;
    border: none;
  }

  .react-datepicker__input-time-container {
    margin: -1px 0 10px 20px;
  }

  input[type="time"],
  input[type="time"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }
`;

export const StyledFileWrapper = styled.div`
margin: 1em;
margin-left: 0;
display: flex;
justify-content: space-between;
`
export const StyledDeleteButton = styled(Button)`
position: absolute;
top: 5px;
right: ${props => props.rightAlign ? `${props.rightAlign}px` : '0'};
`

export const StyledFileLabel = styled(Label)`
display: flex !important;
cursor: pointer;
width: 350px;
 .fileName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
 }
`